const MAPBOX_TOKEN = "pk.eyJ1IjoiZmxvcmlhbnBpY2ttZSIsImEiOiJja2hoeTQzbmQxMDIxMnhud29tMjNkdnhzIn0.a4zg2O1xKCQPakVW32DsCw"
export default MAPBOX_TOKEN
